import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { DealerPortalBanner } from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

type BannerResponse = {
  success: boolean;
  banner: DealerPortalBanner | null;
};

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private readonly httpClient = inject(HttpClient);

  // EXT-6166: served by the accounts container, which filters by the calling
  // dealer's ecomStatus. The old imaging '/api/1/dealerPortalBanner' route only
  // returns All Dealers banners now.
  private readonly apiUrl = environment.banner_api_server_url;

  private reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  public getCurrentBanner(): Observable<BannerResponse> {
    return this.httpClient
      .get<DealerPortalBanner | null>(`${this.apiUrl}/active-banner`, {
        ...requireAppCheck,
        headers: this.reqHeader,
      })
      .pipe(
        map((response) => ({ success: true, banner: response })),
        catchError((error) => {
          console.error(error);
          return of({ success: false, banner: null });
        }),
      );
  }
}
